export const getDomain = () => document.domain;

export const getExchangeOrigin = () => {
  const { protocol } = window.location;
  const domain = getDomain();

  let result = `${protocol}//${domain}`;

  // 测试环境非80端口
  if (/(fixerror.fun)$/.test(domain)) {
    result = `${result}:81`;
  }

  return result;
};

// TODO: 通过打包环境区分
export const getUserCenterOrigin = () => {
  const { protocol } = window.location;
  const domain = getDomain();

  const result = domain.includes('hextest.net') ? `${protocol}//hextest.net` : `${protocol}//hextest.net`;

  return result;
};

export const getHref = () => window.location.href;
export const getOrigin = () => window.location.origin;
export const getPathname = () => window.location.pathname;

export const isSpotPage = () => window.location.pathname.includes('spot');
export const getExchangeUrl = () => {
  const domain = getDomain();
  const { protocol } = window.location;
  const href = getHref();
  const pathname = getPathname();
  return {
    home: `${protocol}//${domain}`,
    ws: `${protocol.replace(/^(http)/, 'ws')}//${domain}/ws`,
    spotWs: `${protocol.replace(/^(http)/, 'ws')}//${domain}/ws/socket`,
    login: `/login`,
    signIn: `${protocol}//${domain}/auth/login?redirect=${protocol}//${domain}${pathname}`, // ${protocol}//megabit.${domain}${pathname}
    signUp: `${protocol}//${domain}/auth/register?redirect=${protocol}//${domain}${pathname}`,
    trade: `${getExchangeOrigin()}/trade`,
    quanto: `${getExchangeOrigin()}/fund/quanto`,
    otc: `${getExchangeOrigin()}/otc/index`,
    revoke: `${protocol}//${domain}/uc/uaa/authorize/token/revoke`,
    getCoinConfig: `${getExchangeOrigin()}/exchange-main/api/web/1_0_0/getCoinConfig`,
    getUserFund: `${getExchangeOrigin()}/exchange-main/api/web/1_0_0/getUserFund`,
    getUserLeverFund: `${getExchangeOrigin()}/exchange-main/api/web/1_0_0/getUserLeverFund`,
    // getLeverMarketConfig: `${getExchangeOrigin()}/xt-lever/marketConfig`,
    transfer: `${getExchangeOrigin()}/exchange-main/api/web/1_0_0/transfer`,
    getAssistPrice: `/attr/a/coins/mon`, // pro价格接口汇率
    securityCenter: `${protocol}//${domain}/account/u/user/security`, // 安全中心
    realName: `${protocol}//${domain}/account/user/verified`, // 实名认证
    superPartner: `${protocol}//${domain}/account/user/invite`, // 邀请返佣
    // myVouchers: `${getExchangeOrigin()}/account/coupon`, // 我的券包
    apiMgmt: `${protocol}//${domain}/application/api`, // API管理
    safelyLogout: `/lv/need/t/user/logout`, // 安全退出
    accountCancellation: `/lv/need/t/user/accountCancellation`, // 注销账户
    downloadApp: `${getExchangeOrigin()}/app`,
    recommend: `${getExchangeOrigin()}/auth/register`, // 邀请注册
    getUserInfo: `/lv/need/t/user/getinfos`, // 获取用户信息
    carouselList: `/attr/a/getBannerList`, // banner
    appUrl: `/lv/common/a/check/version`, // app 下载地址
    ticker: `/pro/p/quotation/q/agg-ticker`, // market
    registers: '/lv/common/a/register',
    country: '/lv/common/a/getCountryCodeList',
    sendMsg: '/lv/common/a/sendMsg', //judgeToken未登录
    sendMsgLogin: '/lv/need/t/sendLoginMsg',
    init: '/lv/common/a/geetestInit',
    judge: '/lv/common/a/have/name', // userName countryCode:
    loginToken: '/lv/common/a/login/first', // 登录第一步 username password telCountryCode
    suffix: '/lv/common/a/login/second', // token ticket, prefixAuth(loginToken返回的msg) phoneCode
    wsToken: '/attr/t/listenkey',
    reset: '/lv/common/a/reset/first',
    resetSuffix: '/lv/common/a/reset/second',
    setReceipt: '/foreign/user/setReceipt',
    bills: '/attr/t/fund/bill/getBalanceBills', // 现货流水get
    bills_otc: '/attr/t/fund/bill/getOtcBalanceBills', //资金账户流水get
    coinAddress: '/attr/t/recharge/address', // 币种充值地址  coinType: USDT chain: TRC20 get
    addressList: '/attr/t/withdraw/address/getAddressList', // 地址管理get
    addAddress: '/attr/t/withdraw/address/add', // 增加地址post coinType name昵称 coinWallet地址
    removeAddress: '/attr/t/withdraw/address/delete', // 删除地址
    updateAddress: '/attr/t/withdraw/address/update', // 更新地址
    createWithdraw: '/attr/t/withdraw/create', // 创建提现 验证码 密码 post
    checkAddress: '/attr/t/withdraw/checkAddress', // 是否内部地址 get coin: USDTaddress: TWjY2nJy1ZbkPYWLDRUNKoiD7bpGb3XcBBchain: TRC20
    withdrawDeposit: '/attr/t/deposit/withdraw/getList', // 充值type0 提现1 记录 get  不传type是冲提记录
    withdrawProgress: '/attr/t/deposit/withdraw/progress', // 链上提现进度详情 id=withdrawId
    balance: '/attr/t/fund/userfund', // 资产 get
    supportAccount: '/attr/t/wallet/getWalletType', // 支持的资产类型 get
    quota: '/attr/t/withdraw/getWithdraw', // 提现 剩余可用额度 coin=USDT get
    projectSource: '/pro/invitation/reward/project-source',
    transferList: '/attr/t/wallet/getTransferList', // 划转历史
    transferBalance: `/attr/t/wallet/userTransfer`, // 划转功能
    supportCoin: `/attr/t/wallet/getTransferCoins`, // 获取支持的划转币种 fromWalletType=spot&toWalletType=contract
    introduction: '/attr/a/coin/introduction/getDetail', // currency=BTC币种介绍
    depth: '/attr/a/marketcondition/getDepth', // level=50&symbol=BTC_USDT 买卖深度
    kline: '/attr/a/marketcondition/getKline',
    deal: '/attr/a/marketcondition/getDeals', // level=50&symbol=BTC_USDT 获取成交历史
    tickers: '/attr/a/marketcondition/getTickers', // 所有币对行情
    tickersKline: '/attr/a/marketcondition/getTickersAndKlineList',
    tickersKredis: '/attr/a/marketcondition/getTickersAndKline',
    spotCreateOrder: '/attr/t/lm/order/createOrder', // 现货下单
    spotCancelOrder: '/attr/t/lm/order/cancelOrder', // 取消下单
    spotCancelDeal: '/attr/t/lm/order/getTradeList',
    spotCancelDetail: '/attr/t/lm/order/getOrderByOrderId', // 下单详情
    history: '/attr/t/lm/order/getHistoryOrders', // 现货历史委托
    spotOrderList: '/attr/t/lm/order/getOrders', // 订单记录现货 当前委托symbol=BTC_USDT
    symbolaAll: '/attr/a/tradepairs/getAllSymbols', // 获取全部交易对列表用于下拉币对列表
    symbolList: '/attr/a/tradepairs/getList', // 获取交易对配置列表
    coinsList: '/attr/a/coins/getCoinsConfig', // 币种列表
    setList: '/attr/a/coins/getList', //
    confAllSpot: '/attr/a/conf/fund/spot', // 现货流水类型
    confALLOtc: '/attr/a/conf/fund/otcBalanceBillTypes', // 资金账户流水类型
    depositWithdrawRecord: '/pro/deposit/u/withdraw/coin/record', // 充值提现记录 type1提现 0充值
    isLogin: '/uc/user/is-login', // 是否登录
    media: '/attr/a/media/url',
    telegram: '/attr/a/telegram/url',
    ticket: '/uc/user/get/ticket',
    google: '/lv/need/t/getGoogleAuthCode', // 谷歌二维码
    identity: '/lv/need/t/user/idesntityAuth',
    upload: '/lv/need/t/file/upload',
    changeAvatar: '/lv/need/t/user/getSiteUser', // 修改头像
    invitedUrl: '/lv/need/t/user/urllist', // 邀请链接
    addApi: '/lv/need/t/apiUser/addUserApi', // 新增api
    updateStatusApi: '/lv/need/t/apiUser/updateUserApi', // 更新api状态
    updateApi: '/uc/u/apiUser/update', // 更新api状态
    deleteApi: '/lv/need/t/apiUser/deleteUserApi', // 删除api
    apiUserList: '/lv/need/t/apiUser/listUserApi', // API列表
    invitedPeople: '/lv/need/t/user/invited/count', // 邀请人数
    invitedInfo: '/lv/need/t/user/invited/info', // 邀请记录
    invitationList: '/attr/t/invitation/reward/getRewardList', // 奖励记录
    passwordUpdate: '/lv/need/t/user/changePassword', // 更新密码
    sendCode: '/lv/need/t/sendLoginMsg',
    securityEnable: '/lv/need/t/user/security/enableSecurity',
    collectionList: '/attr/t/collection/getCollectionList', // 收藏币种列表
    collectionAdd: '/attr/t/collection/addCollect', // 新增收藏币种
    collectionRemove: '/attr/t/collection/cancelCollect', // 移除收藏币种
    postersList: '/uc/posters/list', // 用户专属海报
    securityGoogle: '/lv/need/t/user/security/verifyGoogle', // 绑定谷歌
    securityPhone: '/lv/need/t/user/security/verifyPhone', // 绑定手机
    securityEmail: '/lv/need/t/user/security/verifyEmail', // /绑定邮箱
    changePassword: '/lv/need/t/user/changePassword', // 修改密码
    notice: '/attr/a/noticelist', // 公告
    loginRecord: '/lv/need/t/user/loginLog', // 登录日志
    rewardAmount: '/attr/t/invitation/reward/getRewardTotal', // 累计返佣金额/
    conf: '/attr/a/getFunctionUrl',
    coinsLogo: '/attr/a/coins/pics', //币种图片
    znxList: '/attr/t/mail/getList', //站内信列表
    znxRead: '/attr/t/mail/readZnxMessage', //读取站内信消息
    znxListAll: '/attr/t/mail/getAllZnxMessage', //读取所有站内信消息
    znxReadAll: '/attr/t/mail/readAllZnxMessage', //全部已读
  };
};

export const getQuery = (query: string) => {
  const url = getHref();
  const str = url.substring(url.indexOf('?') + 1);
  const arr = str.split('&');
  const result: any = {};

  for (let i = 0; i < arr.length; i++) {
    const item = arr[i].split('=');
    result[item[0]] = item[1];
  }

  return result[query];
};

export const isFromMobile = () => {
  const from = getQuery('from');

  return from === 'app' || from === '__from__';
};
